import { createFileRoute, redirect } from "@tanstack/react-router";

/** Public contracts (invoices) replace the old vendor contract list. */
export const Route = createFileRoute("/vendor/contract/")({
	beforeLoad: () => {
		throw redirect({ to: "/vendor/invoices" });
	}
});
